import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {
  CustomerRecordOwnerUserListComponent
} from "./customer-record-owner-user-list/customer-record-owner-user-list.component";
import {
  CustomerRecordOwnerGroupListComponent
} from "./customer-record-owner-group-list/customer-record-owner-group-list.component";
import {RightModel} from "../../../app.rights";

@Component({
  selector: 'app-customer-record-owners',
  templateUrl: './customer-record-owners.component.html',
  styleUrls: ['./customer-record-owners.component.scss']
})
export class CustomerRecordOwnersComponent implements OnInit {


  @Input()
  customerId: number;

  @Input()
  customerRecordId: number;

  @Input()
  readonly: boolean = true;

  @ViewChild(CustomerRecordOwnerUserListComponent)
  userListComponent: CustomerRecordOwnerUserListComponent;

  @ViewChild(CustomerRecordOwnerGroupListComponent)
  groupListComponent: CustomerRecordOwnerGroupListComponent;

  @Input()
  rightModel: RightModel = RightModel.empty();

  ngOnInit(): void {
  }

  initComponent() {
    this.userListComponent.initComponent();
    this.groupListComponent.initComponent();
  }

}
